import { useState } from 'react'
import { Stack, Text, TextInput, PasswordInput, Button, Paper } from '@mantine/core'
import { IconUser, IconLock, IconMail, IconCheck } from '@tabler/icons-react'
import { useAuth } from '../../hooks/useAuth'

const inputStyles = {
  input: {
    background: 'rgba(10, 22, 40, 0.8)',
    border: '1px solid rgba(0, 255, 255, 0.15)',
    color: '#e0e8f0',
  },
  label: { color: 'var(--mantine-color-gray-4)' },
}

export function UpgradeForm({ title, description, buttonLabel = 'Create Account', buttonColor, successMessage }) {
  const { user, upgradeAccount } = useAuth()
  const [name, setName] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [confirmError, setConfirmError] = useState('')
  const [upgraded, setUpgraded] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!name.trim() || !password) return

    if (password !== confirmPassword) {
      setConfirmError('Passwords do not match')
      return
    }

    setLoading(true)
    setError('')
    setConfirmError('')

    const result = await upgradeAccount(name.trim(), password, confirmPassword)
    setLoading(false)

    if (result.success) {
      setUpgraded(true)
    } else {
      setError(result.error)
    }
  }

  if (upgraded) {
    return (
      <Paper p="lg" className="glass" w="100%">
        <Stack align="center" gap="sm">
          <IconCheck size={32} color="var(--mantine-color-cyan-4)" />
          <Text c="cyan.4" fw={600} ta="center">
            {successMessage || 'Account upgraded successfully!'}
          </Text>
        </Stack>
      </Paper>
    )
  }

  return (
    <Paper p="lg" className="glass" w="100%">
      <Stack gap="md">
        {title && (
          <Text fw={600} ff="Orbitron, sans-serif" c={buttonColor || 'cyan.4'} size="sm" ta="center">
            {title}
          </Text>
        )}
        {description && (
          <Text c="dimmed" size="sm" ta="center">
            {description}
          </Text>
        )}

        <form onSubmit={handleSubmit}>
          <Stack gap="sm">
            <TextInput
              label="Email"
              value={user?.email || ''}
              readOnly
              leftSection={<IconMail size={16} />}
              autoComplete="email"
              styles={{
                ...inputStyles,
                input: {
                  ...inputStyles.input,
                  opacity: 0.6,
                  cursor: 'default',
                },
              }}
            />
            <TextInput
              label="Name"
              placeholder="Your name"
              leftSection={<IconUser size={16} />}
              value={name}
              onChange={(e) => setName(e.currentTarget.value)}
              required
              autoComplete="name"
              styles={inputStyles}
            />
            <PasswordInput
              label="Password"
              placeholder="Choose a password"
              leftSection={<IconLock size={16} />}
              value={password}
              onChange={(e) => setPassword(e.currentTarget.value)}
              required
              minLength={6}
              error={error}
              autoComplete="new-password"
              styles={inputStyles}
            />
            <PasswordInput
              label="Confirm Password"
              placeholder="Re-enter your password"
              leftSection={<IconLock size={16} />}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.currentTarget.value)}
              required
              minLength={6}
              error={confirmError}
              autoComplete="new-password"
              styles={inputStyles}
            />
            <Button type="submit" loading={loading} fullWidth size="sm" color={buttonColor}>
              {buttonLabel}
            </Button>
          </Stack>
        </form>
      </Stack>
    </Paper>
  )
}
